/**
 * Shared intake field styles (DESIGN.md): 44px tall, 16px text so iOS Safari doesn't zoom on
 * focus, navy focus ring. Errors swap the border to red via `fieldInputErrorClass`.
 */
export const fieldInputClass =
  "block min-h-11 w-full rounded-lg border border-[#e2e2ec] bg-white px-3 py-2 text-base text-[#1E252B] focus:border-[#2A4064] focus:outline-none focus:ring-2 focus:ring-[#2A4064]/30";

export const fieldInputErrorClass = "border-[var(--hs-red)]";
